export const transformImageUrlToSize = (url: string, width: number, height: number): string =>
    url?.replace(`:width`, `${width}`).replace(`:height`, `${height}`)

export const defaultAdditionalWidths = [768, 384]

export const PLACEHOLDER_BLUR_BASE64 =
    'data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAAKAAoDAREAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAcK/8QAJRAAAQIEBAcAAAAAAAAAAAAAAQIRABIhYQMxQVEFFSJSkqHR/8QAGQEAAgMBAAAAAAAAAAAAAAAAAgQBAwUG/8QAJREBAAAFAQgDAAAAAAAAAAAAAQACESExQRIiQlFhkaHBcbHR/9oADAMBAAIRAxEAPwDPPg8des5DuBNqTUBnYFqOTvuWwiRKJMltVoGvM64rrkjoV6mbWDNaHP14hPOgKTmlgfesBvHHN3H1B7K3pLe/F+xNsBazmpR6lZqN7wzIGw20l85iuFTr7leR+wvV5vdiXL8v3H//2Q=='

export const transformImageUrlToSrcSet = (
    url: string,
    width: number,
    height: number,
    additionalWidths: number[] = defaultAdditionalWidths //allows caller to specify custom additional widths
): string => {
    const ratio = width / height
    let srcSet = `${transformImageUrlToSize(url, width, height)} 1024w`

    additionalWidths.forEach(aw => {
        if (width > aw) {
            srcSet = `${transformImageUrlToSize(url, aw, Math.floor(aw / ratio))} ${aw}w,${srcSet}`
        }
    })

    return srcSet
}
